import { carrierCodeResources, carrierNameResources } from '../resources/carrierCodeResources'
import { CollectTrackingResultType } from '../enums/CollectTrackingResultType'
import { PeriodTypeForOrdersInTransport } from '../enums/PeriodTypeForOrdersInTransport'
import { StateOrderIdentification } from '../enums/StateOrderIdentification'
import { CollectTracking } from '../models/CollectTracking'
import { ErpNfe } from '../models/ErpNfe'
import { GetOrderAddressesOutput } from '../services/Orders/GetOrderAddresses/GetOrderAddressesOutput'

export const ManageTransportHelper = {

  getDescriptionOfPeriodTypeForOrdersInTransport: (periodType: PeriodTypeForOrdersInTransport) => {
    switch (periodType) {
      case PeriodTypeForOrdersInTransport.LastPackageStatus:
        return 'Último Status do Pacote';
      case PeriodTypeForOrdersInTransport.OrderDispatched:
        return 'Pedido Enviado';
      case PeriodTypeForOrdersInTransport.OrderCreated:
        return 'Pedido Criado';
      case PeriodTypeForOrdersInTransport.LastPackageStatusAndOrderCreated:
        return 'Último Status do Pacote e Pedido Criado';
      case PeriodTypeForOrdersInTransport.LastPackageStatusAndOrderDispatched:
        return 'Último Status do Pacote e Pedido Enviado';
      case PeriodTypeForOrdersInTransport.OrderDispatchedAndOrderCreated:
        return 'Pedido Enviado e Criado';
      default:
        return ''
    }
  },

  getCollectTrackingStatus: (collectTracking: CollectTracking) => {
    switch (collectTracking.collectTrackingResultType) {
      case CollectTrackingResultType.PendingSystem:
        return {
          text: 'Coleta virtual pendente de realização automática.',
          details: ''
        }
      case CollectTrackingResultType.Failed:
        return {
          text: 'Coleta virtual não realizada por falha.',
          details: collectTracking.resultDetails
        }
      case CollectTrackingResultType.Success:
        return {
          text: 'Coleta virtual realizada com sucesso.',
          details: collectTracking.resultDetails
        }
      case CollectTrackingResultType.PendingUser:
        return {
          text: 'Coleta virtual pendente de realização manual.',
          details: collectTracking.resultDetails
        }
      default:
        return {
          text: 'Coleta virtual não realizada até o momento.',
          details: ''
        }
    }
  },
  
  getDocumentNumber: (nfe?: ErpNfe, orderAddresses?: GetOrderAddressesOutput|null) => {
    let documentNumber = nfe?.nfeDestinationAddressList && nfe?.nfeDestinationAddressList.length > 0
      ? nfe?.nfeDestinationAddressList[0].documentNumber
      : null;

    if (!documentNumber && orderAddresses?.shippingAddresses && orderAddresses?.shippingAddresses.length > 0) {
      const shippingAddresses = orderAddresses?.shippingAddresses.filter(address => address.company && address.company.length > 0);
      if (shippingAddresses && shippingAddresses.length > 0) {
        documentNumber = shippingAddresses[0].company;
      }
    }

    if (!documentNumber && orderAddresses?.billingAddresses && orderAddresses?.billingAddresses.length > 0) {
      const billingAddresses = orderAddresses?.billingAddresses.filter(address => address.company && address.company.length > 0);
      if (billingAddresses && billingAddresses.length > 0) {
        documentNumber = billingAddresses[0].company;
      }
    }

    if (!documentNumber && orderAddresses?.customer && orderAddresses?.customer?.document) {
      documentNumber = orderAddresses?.customer?.document;
    }

    return documentNumber;
  },

  getExternalLink: (
    shippingLineCode?: string | null,
    keyNfe?: string | null,
    orderNumber?: string | null,
    numberNfe?: string | null,
    trackingCode?: string | null,
    billcode?: string | null,
    cpf?: string | null
  ) => {
    if (shippingLineCode === carrierCodeResources.Loggi || shippingLineCode === carrierNameResources.Loggi) {
      if (trackingCode) {
        return `https://www.loggi.com/rastreador/92cf9c9340/${trackingCode}`;
      } else
      if (keyNfe) {
        return `https://www.loggi.com/rastreador/92cf9c9340/${keyNfe}`;
      }
    }
    if (shippingLineCode === carrierCodeResources.TotalExpress && numberNfe && orderNumber) {
      return `https://tracking.totalexpress.com.br/poupup_track.php?reid=23839&pedido=${orderNumber}&nfiscal=${numberNfe}`;
    }
    if (shippingLineCode === carrierCodeResources.JTExpress && billcode) {
      return `https://www.jtexpress.com.br/trajectoryQuery?waybillNo=${billcode}&type=0&cpf=${cpf}`;
    }

    return '';
  },

  getOrderStateFilterValues: () => {
    return [
      {
        code: 'coleta_enviado_transporte',
        display: 'Em Coleta, Enviado e Transporte',
        states: [
          StateOrderIdentification.Enviado,
          StateOrderIdentification.EmColeta,
          StateOrderIdentification.EmTransporte,
          StateOrderIdentification.EmTransporteAlertaInterno,
          StateOrderIdentification.EmTransporteAlertaInternoExterno,
          StateOrderIdentification.NaoEntregueAlertaInterno,
          StateOrderIdentification.NaoEntregueAlertaInternoExterno
        ]
      },
      {
        code: 'enviado',
        display: 'Enviado',
        states: [
          StateOrderIdentification.Enviado
        ]
      },
      {
        code: 'coleta',
        display: 'Em Coleta',
        states: [
          StateOrderIdentification.EmColeta
        ]
      },
      {
        code: 'transporte',
        display: 'Em Transporte',
        states: [
          StateOrderIdentification.EmTransporte
        ]
      },
      {
        code: 'transporte_alerta',
        display: 'Em Transporte - Alerta',
        states: [
          StateOrderIdentification.EmTransporteAlertaInterno,
          StateOrderIdentification.EmTransporteAlertaInternoExterno
        ]
      },
      {
        code: 'entregue',
        display: 'Entregue',
        states: [
          StateOrderIdentification.Entregue
        ]
      },
      {
        code: 'nao_entregue_alerta',
        display: 'Não Entregue - Alerta',
        states: [
          StateOrderIdentification.NaoEntregueAlertaInterno,
          StateOrderIdentification.NaoEntregueAlertaInternoExterno
        ]
      },
      {
        code: 'nao_entregue_ok',
        display: 'Não Entregue - OK',
        states: [
          StateOrderIdentification.NaoEntregueOK
        ]
      },
      {
        code: 'todos_inclusive_entregue',
        display: 'Todos inclusive Entregue',
        states: [
          StateOrderIdentification.Enviado,
          StateOrderIdentification.EmColeta,
          StateOrderIdentification.EmTransporte,
          StateOrderIdentification.EmTransporteAlertaInterno,
          StateOrderIdentification.EmTransporteAlertaInternoExterno,
          StateOrderIdentification.NaoEntregueAlertaInterno,
          StateOrderIdentification.NaoEntregueAlertaInternoExterno,
          StateOrderIdentification.NaoEntregueOK,
          StateOrderIdentification.Entregue
        ]
      }
    ];
  },

}